import React from 'react';
import { Input, Select, Icon, Row, Col } from 'antd';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
          
                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={6}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idUsuario ?
                                    { key: this.props.filter.idUsuario } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por usuario" />}
                            onChange={(option) => this.props.onChange("idUsuario", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.empleados.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
           
                </Row>
            </div>
        );
    }
}

export default Filters;